// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37MCK","newExpiryDate":"styles_newExpiryDate__3_0rr","footer":"styles_footer__1vjR-"};